import { type DependencyId } from '@canvas/dependency-config';

export enum FailureReasons {
  PRODUCT_API_FAILURE = 'PRODUCT_API_FAILURE',
  SMART_LINK_RESOLVE_FAILURE = 'SMART_LINK_RESOLVE_FAILURE',
  GENERATE_STICKIES_RESOLVE_FAILURE = 'GENERATE_STICKIES_RESOLVE_FAILURE',
  AI_CLUSTERING_API_FAILURE = 'AI_CLUSTERING_API_FAILURE',
  AI_TEAMMATE_API_FAILURE = 'AI_TEAMMATE_API_FAILURE',
  JIRA_IMPORT_NLP_MODE_SELECTOR = 'JIRA_IMPORT_NLP_MODE_SELECTOR',
  JIRA_IMPORT_SITE_DROPDOWN = 'JIRA_IMPORT_SITE_DROPDOWN',
}

export interface FailureSummary {
  /**
   * The source of the failure. Typically an external API which we depend upon.
   */
  source: FailureReasons;
  /**
   * The API client were the error was encountered.
   */
  location: string;
  /**
   * The API endpoint which was being communicated with.
   * NOTE: This information will be logged in our pollinator logs so
   * be careful with sensitive information (e.g. PII, UGC).
   */
  endpoint: string;

  /**
   * Optional ID that SHOULD point to a real dependency in @canvas/dependency-config.
   * If you use this parameter, our downstream code will fire a custom signalFX
   * metric which will notify the team defined in the dependency-config.
   */
  dependencyId?: DependencyId;
}
